import { Action, User, Location } from '../../models';
import { getFilteringActions, getFilteringLocations, getFilteringPerformers } from '../../services';
import * as actionTypes from './types';

export const setFilteringActions = (value) => {
  return {
    type: actionTypes.SET_FILTERING_ACTIONS,
    value: value,
  };
};

export const setFilteringLocations = (value) => {
  return {
    type: actionTypes.SET_FILTERING_LOCATIONS,
    value: value,
  };
};

export const setFilteringPerformers = (value) => {
  return {
    type: actionTypes.SET_FILTERING_PERFORMERS,
    value: value,
  };
};

export const setFilteringChips = (value) => {
  return {
    type: actionTypes.SET_FILTERING_CHIPS,
    value: value,
  };
};

export const fetchFilteringActions = () => async (dispatch, getState) => {
  const { account, authenticityToken } = getState().internalReducer.internal;
  dispatch(setFilteringActions({ data: [], error: null, loading: true }));

  try {
    const response = await getFilteringActions({ accountId: account.id, authToken: authenticityToken });

    dispatch(
      setFilteringActions({
        data: response.map((action) => new Action(action)),
        error: null,
        loading: false,
      }),
    );
  } catch (error) {
    dispatch(setFilteringActions({ data: [], error: error, loading: false }));
  }
};

export const fetchFilteringLocations = () => async (dispatch, getState) => {
  const { account, authenticityToken } = getState().internalReducer.internal;
  dispatch(setFilteringLocations({ data: [], error: null, loading: true }));

  try {
    const response = await getFilteringLocations({ accountId: account.id, authToken: authenticityToken });

    dispatch(
      setFilteringLocations({ data: response.map((location) => new Location(location)), error: null, loading: false }),
    );
  } catch (error) {
    dispatch(setFilteringLocations({ data: [], error: error, loading: false }));
  }
};

export const fetchFilteringPerformers = () => async (dispatch, getState) => {
  const { account, authenticityToken } = getState().internalReducer.internal;
  dispatch(setFilteringPerformers({ data: [], error: null, loading: true }));

  try {
    const response = await getFilteringPerformers({ accountId: account.id, authToken: authenticityToken });

    dispatch(
      setFilteringPerformers({ data: response.map((performer) => new User(performer)), error: null, loading: false }),
    );
  } catch (error) {
    dispatch(setFilteringPerformers({ data: [], error: error, loading: false }));
  }
};
